import { createContext } from 'react'
import { InteractionName, InteractionType } from '@components/interactionContext/types'

type InteractionContextType = {
  name: InteractionName
  type: InteractionType
}

export const InteractionContext = createContext<InteractionContextType>({
  name: 'insurance-panel',
  type: 'check-eligibility',
})
